"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PonziEventType = void 0;
var PonziEventType;
(function (PonziEventType) {
    PonziEventType["RuleCreatedP"] = "RuleCreatedP";
    PonziEventType["RuleUpdated"] = "RuleUpdated";
    PonziEventType["StakingStart"] = "StakingStart";
    PonziEventType["StakingWithdraw"] = "StakingWithdraw";
    PonziEventType["StakingFinish"] = "StakingFinish";
    PonziEventType["WithdrawToken"] = "WithdrawToken";
    PonziEventType["FinalizedToken"] = "FinalizedToken";
    // MODULE:WALLET
    PonziEventType["PayeeAdded"] = "PayeeAdded";
    PonziEventType["PaymentReleased"] = "PaymentReleased";
    PonziEventType["ERC20PaymentReleased"] = "ERC20PaymentReleased";
    PonziEventType["PaymentReceived"] = "PaymentReceived";
})(PonziEventType || (exports.PonziEventType = PonziEventType = {}));
//# sourceMappingURL=ponzi.js.map